import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Map of routes to page titles (German labels)
const PAGE_TITLES: Record<string, string> = {
  "/dashboard": "Dashboard",
  "/chats": "Live Chat",
  "/experts": "Experten",
  "/products": "Produkte",
  "/replacement_parts": "Ersatzteile",
  "/team": "Team",
  "/usage": "Nutzungsstatistiken",
  "/documents": "Dokumente",
  "/db-tables": "Datenbanktabellen",
  "/administration": "Administration",
  "/ontology/prescriptive": "Präskriptives Wissen",
  "/ontology/pipeline": "Wissensaufbau-Pipeline",
  "/archive": "Archiv",
  "/knowledge_base": "Wissensdatenbank",
  "/retriever-test": "Retriever Test",

  // Settings pages
  "/settings": "Einstellungen",
  "/settings/intents": "Absichten",
  "/settings/cg": "Konversationsschnittstellen",
  "/settings/ms-exchange": "Microsoft Exchange",
  "/settings/data-clients": "Datenquellen",
};

/**
 * Custom hook to update the document title based on the current route
 */
export function usePageTitle() {
  const location = useLocation();

  useEffect(() => {
    // Get the base path (without dynamic segments like :id)
    const pathname = location.pathname;

    // Try exact match first
    let pageTitle = PAGE_TITLES[pathname];

    // If no exact match, try to find a matching base path
    if (!pageTitle) {
      // Handle dynamic routes like /products/:productId, etc.
      const pathSegments = pathname.split("/").filter(Boolean);

      if (pathSegments.length > 0) {
        // Try matching against base paths
        const basePath = `/${pathSegments[0]}`;
        pageTitle = PAGE_TITLES[basePath];

        // For nested routes like /settings/account
        if (pathSegments.length > 1) {
          const nestedPath = `/${pathSegments[0]}/${pathSegments[1]}`;
          pageTitle = PAGE_TITLES[nestedPath] || pageTitle;
        }

        // For products with IDs
        if (pathSegments.length > 1 && pathSegments[0] === "products") {
          pageTitle = "Produkt";
        }

        // For archive with IDs
        if (pathSegments.length > 1 && pathSegments[0] === "archive") {
          pageTitle = "Archiv";
        }

        // For db-tables with IDs
        if (pathSegments.length > 1 && pathSegments[0] === "db-tables") {
          pageTitle = "Datenbanktabelle";
        }
      }
    }

    // Update document title
    const fullTitle = pageTitle ? `lytra AI - ${pageTitle}` : "lytra AI";
    document.title = fullTitle;
  }, [location.pathname]);
}
